/**
* 功能: 文章列表显示，文章的数据审核，新增、修改，删除数据
* 只有最高权限的人可以审核, 其他权限可以提交审核
*/

<template lang="pug">
  .main
    el-form(:inline="true" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-form-item(label="标题")
         el-input.filter(placeholder="标题查询" v-model="search" :size="GLOBAL.SIZE_OF_INPUTBOX" @change="handelKeyinSearch" :clearable="true")
          el-button(slot="append" icon="el-icon-search" @click="handleSearch")
      //- el-form-item(label="属性")
      //-   el-select.filter(:size="GLOBAL.SIZE_OF_INPUTBOX" clearable v-model="selectedProperties" @change="handelChangeProperty" placeholder="选择属性类型")
      //-     el-option(v-for="item in properties" :key="item" :label="item" :value="item")
      //- el-form-item(label="行业")
      //-   FrostIndustry.filter(v-model="industryId" :isshow="false" v-on:changeIndustryId="handelIndustryChange")
      el-form-item(label="状态")
        el-select.filter(v-model="status" multiple placeholder="请选择" :size="GLOBAL.SIZE_OF_INPUTBOX" @change="handelKeyinSearch")
          el-option(
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value")
    el-table(:data='tableData' v-loading='loading' stripe)
      el-table-column(prop='_id' label='编号' width="100" fixed show-overflow-tooltip)
      el-table-column(prop='image' label='图' width="100" fixed)
        template(slot-scope="scope")
          el-upload.avatar-uploader(name="image"
                                    :data="{id:scope.row._id}"
                                    :headers="headers"
                                    accept="image/jpeg,image/png"
                                    :action='action'
                                    :show-file-list="false"
                                    :on-success="uploaded")
            img(v-if='scope.row.image' :src="scope.row.image" style="max-width:100px;max-height:40px;")
            el-tooltip.item(v-else effect="dark" content="上传头图" placement="top")
              el-button(type="primary" round :size="GLOBAL.SIZE_OF_INPUTBOX"  icon="el-icon-upload")
      el-table-column(prop='title' label='标题' width="250" show-overflow-tooltip)
      el-table-column(prop='pubDate' label='发布日期' width="200" :formatter="(row)=>{return row.pubDate ? new Date(row.pubDate).toLocaleString():'无日期'}")
      el-table-column(prop='labels' label='标签' :formatter="(row)=>{return row.labels?row.labels.join(','):''}")
      el-table-column(prop='report' label='关联报告' show-overflow-tooltip)
      //- el-table-column(prop='properties' label='属性' :formatter="(row)=>{return row.properties?row.properties.join(','):''}")
      //- el-table-column(prop='industry' label='行业' show-overflow-tooltip)
      //-   template(slot-scope="scope")
      //-     span(v-if="scope.row.industry" v-html="scope.row.industry.join('<br />')")
      el-table-column(prop='updatedAt' label='更新时间'  show-overflow-tooltip)
        template(slot-scope="scope")
          p {{scope.row.updatedAt | changeData}}
      el-table-column(prop='updatedByName' label='更新用户'  show-overflow-tooltip)
      el-table-column(prop='available' label='状态' width="90" align="center")
        template(slot-scope="scope")
            p {{scope.row.status | status}}
      el-table-column(align='center' label='操作' width="200" fixed="right")
        template(slot="header" slot-scope="scope")
          el-button(v-if="hasEditAuth" type="success" :size="GLOBAL.SIZE_OF_INPUTBOX"  @click="addNew") 新建
        template(slot-scope="scope")
          el-button-group
            el-button(v-if="hasEditAuth" type="warning" icon="el-icon-edit" size="mini" @click="modify(scope.row._id, scope.$index)" round)
            el-button(type="danger" icon="el-icon-delete" size="mini" @click="deleteArticle(scope.row._id)" round v-if="(scope.row.status === undefined || scope.row.status === 0 || scope.row.status === -1) && hasReviewAuth")
            // 状态，0=草稿；-1=退回修改；1=提交待审核；2=已经发布
            template(v-if="scope.row.status !== 1")
              Review(:single.sync="scope.row" url="/article/review")
            template(v-else)
              Review(:single.sync="scope.row" title="通过" type='article' url="/article/review" @sensitive="handleSensitive" ref="successReview")
              Review(:single.sync="scope.row" title="驳回" url="/article/review")
    el-row
      el-col(:span="24")
        el-pagination.pagination(
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="GLOBAL.pageSize"
          layout="total, prev, pager, next"
          :total="total")
    ArticleForm(ref="form" @submit="handleSave" :item="current")
    el-dialog(title='敏感词检测' :visible.sync='isShowSensitiveDialog' width='800px')
      el-row(style='overflow: hidden')
        el-table(:data='currentSensitive' style='width: 100%')
          el-table-column(prop='key' label='类型' width='100')
          el-table-column(prop='error' label='错误' show-overflow-tooltip)
            template(slot-scope='scope')
              span(v-html="scope.row.error.join('<br />')" )
        el-button(type='primary' size='small' style='float: right; margin-top: 20px' @click='close') 前往修改
        el-button(size='small' style='float: right; margin-top: 20px; margin-right: 20px' @click='handleReview()') 仍然提交
</template>

<script>
import passport from '@/javascripts/passport'
import ArticleForm from './components/articleForm'
import FrostIndustry from '@/components/industry'
import api from '@/apis/article'
import { parseTime } from '@/javascripts/time'
import Review from '@/components/Review'
import Enum from '@/apis/enum'

export default {
  name: 'Article',
  components: { FrostIndustry, ArticleForm, Review },
  computed: {
    action () {
      return this.GLOBAL.uploadHost + 'article/header_upload'
    },
    hasEditAuth () {
      return passport.checkAuth([Enum.AUTH.ARTICLE_REVIEW, Enum.AUTH.ARTICLE_EDIT])
    },
    hasReviewAuth () {
      return passport.checkAuth([Enum.AUTH.ARTICLE_REVIEW])
    }
  },
  data () {
    return {
      headers: passport.headers(),
      search: '',
      // selectedProperties: '',
      // properties: ['置顶', '滚动', '焦点', '重要'],
      industryId: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      current: {},
      total: 0,
      options: Enum.STATUS,
      status: [],
      isShowSensitiveDialog: false,
      currentSensitive: []
    }
  },

  methods: {
    close () {
      this.isShowSensitiveDialog = false
    },
    handleSensitive (data) {
      this.currentSensitive = data
      this.isShowSensitiveDialog = true
    },
    handleReview () {
      this.$refs.successReview.handleReview()
      this.close()
    },
    // 实时搜索文章内容
    handelKeyinSearch () {
      this.getArticlePage()
    },
    // 搜索
    handleSearch () {
      this.getArticlePage()
    },
    // handelChangeProperty (e) {
    //   this.getArticlePage()
    // },
    // 根据行业搜索文章
    handelIndustryChange (e) {
      if (this.industryId !== e) {
        this.industryId = [...e]
        this.getArticlePage()
      }
    },
    // 新增文章数据
    addNew () {
      this.$refs.form.show({
        readingCount: 1,
        pubDate: new Date(),
        type: 0,
        status: 0
      })
    },
    // 分页切换
    handleCurrentChange (val) {
      this.currentPage = val
      this.getArticlePage()
    },
    // 保存文章数据
    handleSave (single, cb) {
      const article = JSON.stringify(single)
      if (single._id) {
        api.updateArticle(article).then(r => {
          if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
          if (r) {
            this.$message.success('保存成功')
            this.getArticlePage()
            cb()
          }
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      } else {
        api.createArticle(article).then(r => {
          if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
          if (r) {
            this.$message.success('创建成功')
            this.getArticlePage()
            cb()
          }
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      }
    },
    // 搜索文章分页
    getArticlePage () {
      const single = {
        currentPage: this.currentPage,
        search: this.search,
        // selectedProperties: this.selectedProperties,
        industryId: this.industryId,
        status: this.status
      }
      this.loading = true
      // let singleObj = JSON.stringify(single)
      api.getArticlePage(single).then(r => {
        if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
        this.total = r.data.count
        this.tableData = r.data.data
        this.loading = false
      }).catch(err => {
        this.$message({
          message: err,
          type: 'error'
        })
      })
    },
    // 修改文章数据
    modify (id, index) {
      const single = JSON.parse(JSON.stringify(this.tableData[index]))
      this.$refs.form.show(single)
    },
    // 上传文章头图
    uploaded (result) {
      for (let i = 0;i < this.tableData.length;i++) {
        if (result.data._id === this.tableData[i]._id) {
          this.tableData[i].image = result.data.url
          break
        }
      }
      this.$forceUpdate()
    },
    // 删除文章数据
    deleteArticle (articleId) {
      this.$confirm('此操作将删除该新闻, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteArticle({ id: articleId }).then(r => {
          if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getArticlePage()
        }).catch(err => {
          this.$message({
            message: err,
            type: 'danger'
          })
        })
      })
    }
  },
  mounted () {
    this.getArticlePage()
  },
  filters: {
    changeData: function (val) {
      if (!val) {
        return '暂无日期'
      }

      var date = new Date(val)
      return parseTime(date, '{y}-{m}-{d} {h}:{i}')
    }
  }
}
</script>

<style scoped>
.control {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
}

.control>.filter {
  width: 300px;
  margin-top: 10px;
  margin-right: 30px;
}

.industry {
  flex-grow: 2;
}
</style>